/* Balmohk · comportamiento base de la capa bm- */
(function () {
  const root = document.documentElement;

  /* Alto real del anuncio y del header: lo usan el hero (se mete debajo) y las anclas (scroll-margin-top). */
  function observeHeight(selector, property) {
    const element = document.querySelector(selector);
    if (!element) {
      if (property === '--bm-announcement-height') root.style.setProperty(property, '0px');
      return;
    }
    const write = () => root.style.setProperty(property, `${element.offsetHeight}px`);
    write();
    if ('ResizeObserver' in window) new ResizeObserver(write).observe(element);
  }

  /* Horizon (≥ 990 px) scrollea en .page-wrapper: sin foco, Av Pág / Espacio / Fin no la mueven.
     El foco pasa a .page-wrapper recién con la primera tecla de scroll (no al cargar): así el primer Tab
     sigue yendo a «Saltar al contenido». */
  const SCROLL_KEYS = ['PageDown', 'PageUp', 'End', 'Home', ' ', 'ArrowDown', 'ArrowUp'];

  function focusScroller() {
    const wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return;
    document.addEventListener('keydown', (event) => {
      if (!SCROLL_KEYS.includes(event.key) || !window.matchMedia('(min-width: 990px)').matches) return;
      if (document.activeElement && document.activeElement !== document.body) return;
      if (!wrapper.hasAttribute('tabindex')) wrapper.setAttribute('tabindex', '-1');
      wrapper.focus({ preventScroll: true });
    });
  }

  /* Las secciones de Horizon (PDP, PLP) leen --header-height y --header-group-height del <body>:
     con el header de Horizon apagado, los escribe la capa bm-. */
  function shareHorizonHeights() {
    const header = document.querySelector('.bm-header');
    if (!header || document.querySelector('#header-component')) return;
    const write = () => {
      const announcement = document.querySelector('.bm-announcement');
      const headerHeight = header.offsetHeight;
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      document.body.style.setProperty('--header-group-height', `${headerHeight + (announcement ? announcement.offsetHeight : 0)}px`);
    };
    write();
    if ('ResizeObserver' in window) new ResizeObserver(write).observe(header);
  }

  /* La búsqueda de la tienda es sólo de productos: el formulario del buscador del header (el de Horizon,
     snippets/search-modal) y cualquier otro que vaya a /search llevan type=product */
  function productOnlySearch() {
    const searchPath = (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
    document.querySelectorAll('form[action]').forEach((form) => {
      const action = new URL(form.getAttribute('action'), window.location.origin).pathname;
      if (action !== searchPath || form.querySelector('[name="type"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'type';
      input.value = 'product';
      form.prepend(input);
    });
  }

  function init() {
    observeHeight('.bm-announcement', '--bm-announcement-height');
    observeHeight('.bm-header', '--bm-header-height');
    shareHorizonHeights();
    focusScroller();
    productOnlySearch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
